<script setup lang="ts">
import { storeToRefs } from 'pinia';
import AlertPopup from './AlertPopup.vue';
import { useAppStore } from '../../store/appStore';
import { useRouter } from 'vue-router';

const appStore = useAppStore();
const router = useRouter();

const { needDeleteProject, baseWorkspaceShortLink } = storeToRefs(appStore);

async function deleteProject() {
  const deleteProject = needDeleteProject.value;
  if (deleteProject) {
    appStore.closeDeleteProjectPopup();
    await appStore.deleteProject(deleteProject.short_link);
    await appStore.loadWorkspaces();

    await router.push({
      name: 'workspace',
      params: {
        short_link: baseWorkspaceShortLink.value,
      },
    });
  }
}

function cancelDeleteProject() {
  appStore.closeDeleteProjectPopup();
}
</script>

<template>
  <AlertPopup
    title="Are you sure?"
    subtitle="This will delete directory."
    :cancel="() => cancelDeleteProject()"
    :ok="() => deleteProject()"
    :show="!!needDeleteProject"
  />
</template>
